import { COUNTRY_SHORT_NAMES } from '@entities/country/model/constants';

export const isAE = (country) => country?.toUpperCase() === COUNTRY_SHORT_NAMES.AE;
export const isQA = (country) => country?.toUpperCase() === COUNTRY_SHORT_NAMES.QA;
export const isIQ = (country) => country?.toUpperCase() === COUNTRY_SHORT_NAMES.IQ;
export const isSA = (country) => country?.toUpperCase() === COUNTRY_SHORT_NAMES.SA;
export const isJO = (country) => country?.toUpperCase() === COUNTRY_SHORT_NAMES.JO;
export const isMA = (country) => country?.toUpperCase() === COUNTRY_SHORT_NAMES.MA;
export const isLY = (country) => country?.toUpperCase() === COUNTRY_SHORT_NAMES.LY;
export const isKW = (country) => country?.toUpperCase() === COUNTRY_SHORT_NAMES.KW;
export const isBH = (country) => country?.toUpperCase() === COUNTRY_SHORT_NAMES.BH;
export const isMY = (country) => country?.toUpperCase() === COUNTRY_SHORT_NAMES.MY;
export const isOM = (country) => country?.toUpperCase() === COUNTRY_SHORT_NAMES.OM;
export const isDZ = (country) => country?.toUpperCase() === COUNTRY_SHORT_NAMES.DZ;
export const isID = (country) => country?.toUpperCase() === COUNTRY_SHORT_NAMES.ID;
export const isPT = (country) => country?.toUpperCase() === COUNTRY_SHORT_NAMES.PT;
